import i18n from 'i18next';
import HttpBackend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';
import resourcesToBackend from 'i18next-resources-to-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

import { Config } from './env';

const isServer = typeof window === 'undefined';

const NS = [
  'common',
  'familyInformation',
  'header',
  'validation',
  'dashboard',
  'course',
];

if (!i18n.isInitialized) {
  i18n.use(initReactI18next);

  if (isServer) {
    i18n.use(
      resourcesToBackend(
        (lng: string, ns: string) =>
          import(`../../public/locales/${lng}/${ns}.json`)
      )
    );
  } else {
    i18n.use(LanguageDetector).use(HttpBackend);
  }

  i18n.init({
    ns: NS,
    fallbackLng: 'en',
    initImmediate: !isServer,
    interpolation: { escapeValue: false },

    supportedLngs: Config.supportedLanguages,

    backend: isServer
      ? undefined
      : {
          loadPath: '/locales/{{lng}}/{{ns}}.json',
        },

    detection: isServer
      ? undefined
      : {
          order: ['localStorage'],
          caches: ['localStorage'],
        },
  });
}

export default i18n;
